<div class="w-[700px]">
  <div class="app__itemCard w-full h-auto min-h-[154px] max-h-[310px] justify-start p-0 text-base">
    <div class="flex justify-between items-center p-4 border-b">
      <p class="app__text-higlight flex text-[#1E1E20] text-base m-0">Select Relationship Type</p>
      <span class="material-icons search-icon text-k-black font-bold cursor-pointer" (click)="closeDialog()"> close </span>
    </div>
    <!-- <input type="text" /> -->
    <div class="p-4 relative">
      <div
        [class]="
          'flex items-center gap-2 rounded-lg px-4 p-2 border border-[#ddddd3] font-semibold text-center text-[#515765]  h-16 w-full text-xs sm:text-sm justify-between my-0 '
        "
      >
        <div class="flex gap-2 items-center">
          <app-user-avatar size="32" [name]="selectedUser" cornerRadius="100"></app-user-avatar>
          <div class="flex items-start flex-col" [matTooltip]="selectedUser?.name" matTooltipPosition="above">
            <p class="m-0 text-k-black font-semibold text-sm">{{ selectedUser?.name | truncateStrPipe : 28 }}</p>
            @if(!data?.fromNetworkRegister) {
            <span class="text-k-light-grey font-medium text-xs"> {{ selectedUser?.relationship_name }} </span>
            }
          </div>
        </div>
        <div class="flex gap-3 items-center justify-between">
          <connect-relationship-dialog
            style="margin-top: 8px"
            [hideText]="true"
            (onDatePicked)="doSomething($event)"
            [fromInvite]="true"
            [isGuardian]="false"
            subMemberPlaceHolder="Relationship type"
            [isConnectionModalBtn]="true"
            [isConnectionSearch]="true"
            [filterList]="data?.filterList ?? ''"
            [selectedRelationship]="selectedRelationship"
            [data]="connection_relationship_data"
            [canTruncate]="true"
          >
          </connect-relationship-dialog>
          @if(!data?.fromNetworkRegister) {
          <button class="flex items-center justify-center rounded-[50%] p-3 w-[24px] h-[24px] bg-[#FDf2f2]" (click)="clearUser()">
            <img src="/assets/images/trash-2.svg" alt="" class="w-4 h-4" />
          </button>
          }
        </div>
      </div>
    </div>

    <div class="flex items-center gap-2 text-base justify-end p-4 border-t">
      <button
        [class]="
          selectedRelationshipData
            ? 'app__small__primary__button w-fit m-0 mt-0 px-6 text-xs font-semibold h-8 flex items-center justify-center'
            : 'app__small__primary__disabled mt-3'
        "
        (click)="connectUser()"
      >
        Send Request
      </button>
    </div>
  </div>
</div>
